const CHUNK_RELOAD_FLAG = 'dynamic-import-reload-attempted';

function isChunkLoadError(error) {

  let message = '';

  if (error && error.message) {
    message = error.message;
  }

  if (message.indexOf('Failed to fetch dynamically imported module') !== -1) {
    return true;
  }

  if (message.indexOf('error loading dynamically imported module') !== -1) {
    return true;
  }

  if (message.indexOf('Unable to preload CSS') !== -1) {
    return true;
  }

  return false;

}

function reloadForNewVersion() {

  const alreadyReloaded = window.sessionStorage.getItem(CHUNK_RELOAD_FLAG) === '1';

  if (alreadyReloaded === true) {
    return false;
  }

  window.sessionStorage.setItem(CHUNK_RELOAD_FLAG, '1');
  window.location.reload();

  return true;

}

export function loadModule(importFunction) {

  function handleModuleLoaded(loadedModule) {
    window.sessionStorage.removeItem(CHUNK_RELOAD_FLAG);
    return loadedModule;
  }

  function handleImportError(error) {

    if (isChunkLoadError(error) !== true) {
      throw error;
    }

    const reloaded = reloadForNewVersion();

    if (reloaded !== true) {
      throw error;
    }

    return new Promise(function blockUntilReload() {});

  }

  return importFunction().then(handleModuleLoaded).catch(handleImportError);

}
